var map = {
	"./img_1.jpg": 24750,
	"./img_2.jpg": 88933,
	"./img_3.jpg": 36056,
	"./img_4.jpg": 12593,
	"./img_5.jpg": 35278,
	"./img_6.jpg": 57611,
	"./img_7.jpg": 66779
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91657;